export const build = { date:"2026-02-18.1446", stage:"alpha" }
